import { render, staticRenderFns } from "./infoIndex.vue?vue&type=template&id=2a69bf2c&scoped=true"
import script from "./infoIndex.vue?vue&type=script&lang=js"
export * from "./infoIndex.vue?vue&type=script&lang=js"
import style0 from "./infoIndex.vue?vue&type=style&index=0&id=2a69bf2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69bf2c",
  null
  
)

export default component.exports